import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-email-dashboard',
  templateUrl: './notification-email-dashboard.component.html',
  styleUrls: ['./notification-email-dashboard.component.scss']
})
export class NotificationEmailDashboardComponent {
  activeComponent: string = 'EmailTemplate';

  constructor(private router:Router){}
  setActiveComponent(component: string) {
    this.activeComponent = component;
  }
  back(){
    this.router.navigateByUrl(`/user-settings`)
  }
}
